var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"energy-efficiency"},[(_vm.loadMain)?_c('main-page',{attrs:{"system-info":_vm.systemConfig,"system-data":_vm.systemData,"default-menu-code1":_vm.selectedModuleCode1,"default-menu-code2":_vm.selectedModuleCode2}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21ad9980","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EnergyEfficiency/EnergyEfficiency.vue
// module id = null
// module chunks = 